import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';

export default function ConfirmDialog({
    isOpen,
    msgConfirm,
    closeCallBack,
    okCallBack,
    textSubmit,
    textClose,
    className = '',
    cancelCallBack,
    textCancel,
    cancelClassName = '',
    isShowClassnameButton = true,
    disableButtonCallBack = false
}) {
    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={`wrapDialog ${className}`}
        >
            <DialogContent>
                <div className="confirmPlease">{msgConfirm}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                {okCallBack && (
                    <Button
                        onClick={okCallBack}
                        variant="contained"
                        className={`${isShowClassnameButton && "btn-hg32 btn-handle-delete-user-agree btn-handle-delete-user-agree-important"}`}
                        color={`${!isShowClassnameButton && "primary"}`}
                        disabled={disableButtonCallBack}
                    >
                        {textSubmit ? textSubmit : I18n.get('CM-BUTTON-OK')}
                    </Button>
                )}

                {closeCallBack && (
                    <Button
                        variant="contained"
                        className={`${isShowClassnameButton && "btn-light btn-hg32"}`}
                        onClick={closeCallBack}
                        color="primary"
                        disabled={disableButtonCallBack}
                    >
                        {textClose ? textClose : I18n.get('COMBTN001')}
                    </Button>
                )}

                {cancelCallBack && (
                    <Button
                        variant="contained"
                        onClick={cancelCallBack}
                        color={cancelClassName ? "" : "primary"}
                        className={cancelClassName ? cancelClassName : ''}
                    >
                        {textCancel ? textCancel : I18n.get('COMBTN001')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
